module.exports = __webpack_public_path__ + "img/yitongguo.fb72f90b.png";